import { useQuery } from 'react-query';
import { BackgroundCheck } from '../../../entities/BackgroundCheck';
import {
  ShowParams,
  BackgroundCheckService,
} from '../../../services/v1/BackgroundCheckService';

export const useBackgroundCheck = (params: ShowParams) =>
  useQuery<BackgroundCheck>(
    ['background-check', params.id, params.applicationExternalId],
    async () => {
      if (!params.id && !params.applicationExternalId) return null;

      return await BackgroundCheckService.show(params);
    },
  );
